/**
 * React requires an index.js, but I'm finding that index.js gets overwritten with
 * a react stub index.js... rendering us unable to really debug inside OUR index.js
 * so the solution was to move everything to app.js, which does show up in source maps
 * and can live along-side the index.js replaced by react with their stub.
 */
import { runE2 } from './app';
import _assign from 'lodash/assign';

// prefer lodash assign over the original implementation
Object.assign = _assign;

runE2();
